import React from 'react';

import { Heading } from '../StyledComponents';

import { CalciteLink, CalciteModal } from 'components/Calcite';

import dataSourceUtilities from './data-source-utilities.json';

interface DataUtilitiesModalProps {
  open: boolean;
  onClose: () => void;
}

const DataUtilitiesModal: React.FC<DataUtilitiesModalProps> = ({
  open,
  onClose
}) => (
  <CalciteModal open={open} onClose={onClose} title="Data Source Utilities">
    <div slot="content">
      {Object.entries(dataSourceUtilities).map(([toolGroup, tools], idx) => (
        <div key={toolGroup}>
          <Heading>{toolGroup}</Heading>
          <ul>
            {Object.entries(tools).map(([toolName, link], idx) => (
              <li key={toolName}>
                <CalciteLink href={link}>{toolName}</CalciteLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </CalciteModal>
);

export default DataUtilitiesModal;
